<template>
  <div class="main-card">
    <div class="centercard">
      <!-- 返回按钮 -->
      <div class="return-section">
        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 8 14" fill="none" class="return-icon" @click="$router.go(-1)">
          <path d="M7 1L1 7L7 13" stroke="url(#paint0_linear_5373_11985)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <defs>
            <linearGradient id="paint0_linear_5373_11985" x1="4" y1="1" x2="4" y2="13" gradientUnits="userSpaceOnUse">
              <stop stop-color="#62AFFF"/>
              <stop offset="1" stop-color="#9C41FF"/>
            </linearGradient>
          </defs>
        </svg>
        <span class="person-detail">候选人详情</span>
      </div>
            
      <!-- 候选人资料卡片 -->
      <div class="candidate-card">
        <!-- 头像区域 -->
        <div class="avatar-section">
          <div class="avatar-container" @click="showAvatarModal = true">
            <Avatar :src="avatarUrl" :char="talent.name" :size="80" :bgColor="'rgb(0, 113, 227)'" :alt="talent.name"
              class="candidate-avatar" />
            </div>
          </div>
        
        <!-- 姓名和认证状态 -->
        <div class="name-section">
          <h2 class="candidate-name">{{ talent.name }}</h2>
          <div class="verification-badge">已认证</div>
            </div>
        
        <!-- 操作按钮 -->
        <div class="action-buttons">
          <button class="collect-btn" :class="{ active: talent.is_collected }" @click="toggleCollect">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M4.68149 15.7812C4.00808 16.2103 3.12747 15.9884 2.71846 15.2897C2.52457 14.958 2.46431 14.5618 2.55046 14.1853L3.42207 10.3731C3.43245 10.3287 3.43092 10.2823 3.41765 10.2387C3.40437 10.1951 3.37985 10.1561 3.34667 10.1257L0.493634 7.57598C-0.0989742 7.04676 -0.167375 6.12123 0.339232 5.50422C0.459777 5.35701 0.607562 5.23576 0.774054 5.14746C0.940545 5.05916 1.12244 5.00556 1.30924 4.98977L5.05349 4.67695C5.1351 4.66998 5.2081 4.6148 5.2415 4.5309L6.68412 0.912294C6.98472 0.15846 7.82073 -0.201534 8.55014 0.114974C8.89801 0.266598 9.17325 0.553237 9.31575 0.912294L10.7584 4.5307C10.7918 4.6148 10.8648 4.67018 10.9464 4.67695L14.691 4.98997C15.4762 5.05561 16.0576 5.76801 15.9954 6.57682C15.9662 6.96279 15.7907 7.32164 15.5064 7.57639L12.6534 10.1261C12.587 10.1854 12.557 10.2814 12.578 10.3733L13.4496 14.1855C13.63 14.9742 13.1616 15.7689 12.397 15.959C12.2147 16.0044 12.0254 16.0121 11.8403 15.9816C11.6551 15.9511 11.4776 15.883 11.3184 15.7814L8.11254 13.7383C8.0788 13.7166 8.03977 13.7051 7.99993 13.7051C7.9601 13.7051 7.92107 13.7166 7.88733 13.7383L4.68149 15.7812ZM8.74615 12.6928L11.952 14.7359C12.0012 14.767 12.0592 14.7767 12.1142 14.7629C12.2344 14.733 12.3122 14.6009 12.2816 14.4663L11.41 10.6541C11.3497 10.3918 11.3603 10.1177 11.4405 9.86109C11.5207 9.6045 11.6675 9.37517 11.8652 9.1977L14.7182 6.6482C14.7648 6.60656 14.7942 6.54605 14.7994 6.48C14.81 6.34277 14.7152 6.22667 14.5936 6.21662L10.849 5.90339C10.5866 5.8808 10.3354 5.78408 10.1234 5.62396C9.91134 5.46385 9.74671 5.2466 9.64776 4.99633L8.20514 1.37793C8.18258 1.3198 8.1385 1.27319 8.08254 1.24829C7.97193 1.20029 7.84393 1.25547 7.79513 1.37793L6.35231 4.99633C6.25337 5.2466 6.08873 5.46385 5.87669 5.62396C5.66465 5.78408 5.41349 5.8808 5.1511 5.90339L1.40665 6.21662C1.37776 6.2192 1.34966 6.22763 1.32398 6.24144C1.2983 6.25524 1.27555 6.27414 1.25704 6.29703C1.21624 6.34757 1.19606 6.41232 1.20072 6.47777C1.20538 6.54321 1.23452 6.60427 1.28204 6.6482L4.13508 9.1979C4.33277 9.37537 4.47959 9.60471 4.55979 9.86129C4.63998 10.1179 4.65053 10.392 4.59029 10.6543L3.71868 14.4663C3.70378 14.531 3.71396 14.5991 3.74708 14.6563C3.81248 14.7677 3.94548 14.8011 4.04828 14.7357L7.25432 12.6928C7.47818 12.55 7.73657 12.4742 8.00023 12.4742C8.2639 12.4742 8.52229 12.55 8.74615 12.6928Z"
                fill="url(#paint0_linear_5373_12002)" />
  <defs>
                <linearGradient id="paint0_linear_5373_12002" x1="0" y1="8" x2="16" y2="8"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
    </linearGradient>
  </defs>
</svg>
            <span>收藏</span>
          </button>
          <button class="chat-btn" @click="sendMessage">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16H0.726154C0.533566 16 0.348866 15.9235 0.212686 15.7873C0.0765053 15.6511 0 15.4664 0 15.2738V8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM8 10.9095H4.36267L4.23221 10.9218C4.05662 10.9576 3.9004 11.0569 3.79346 11.2006C3.68652 11.3444 3.63637 11.5226 3.65263 11.701C3.66889 11.8795 3.75041 12.0457 3.88158 12.1678C4.01274 12.2898 4.18433 12.3592 4.36349 12.3627H8L8.13046 12.3504C8.3052 12.3139 8.46043 12.2145 8.56665 12.071C8.67287 11.9275 8.72266 11.75 8.70655 11.5723C8.69045 11.3945 8.60957 11.2288 8.4793 11.1068C8.34903 10.9847 8.17845 10.9148 8 10.9104V10.9095ZM10.9095 8H4.36349L4.23221 8.01231C4.05323 8.0445 3.89282 8.1426 3.78263 8.28725C3.67243 8.4319 3.62044 8.61259 3.63692 8.79369C3.6534 8.97479 3.73716 9.14313 3.87166 9.26551C4.00616 9.38789 4.18164 9.45542 4.36349 9.45477H10.9095L11.04 9.44246C11.2189 9.41028 11.3793 9.31224 11.4894 9.16768C11.5996 9.02312 11.6517 8.84252 11.6353 8.66149C11.6189 8.48046 11.5353 8.31213 11.401 8.18968C11.2667 8.06724 11.0913 7.99956 10.9095 8ZM10.9095 5.09046H4.36349L4.23221 5.10277C4.05323 5.13496 3.89282 5.23306 3.78263 5.37771C3.67243 5.52236 3.62044 5.70306 3.63692 5.88415C3.6534 6.06525 3.73716 6.23359 3.87166 6.35597C4.00616 6.47835 4.18164 6.54588 4.36349 6.54523H10.9095L11.04 6.53292C11.2189 6.50074 11.3793 6.4027 11.4894 6.25814C11.5996 6.11358 11.6517 5.93298 11.6353 5.75195C11.6189 5.57092 11.5353 5.40259 11.401 5.28014C11.2667 5.1577 11.0913 5.09002 10.9095 5.09046Z"
                fill="url(#paint0_linear_5373_12011)" />
  <defs>
                <linearGradient id="paint0_linear_5373_12011" x1="0" y1="8" x2="16" y2="8"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
    </linearGradient>
  </defs>
</svg>
            <span>聊一聊</span>
          </button>
            </div>
        
        <!-- 个人信息 -->
        <div class="info-section">
            <div class="info-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M10 2.8125C10.7005 2.8125 11.3853 3.02022 11.9677 3.40938C12.5501 3.79854 13.0041 4.35167 13.2721 4.99883C13.5402 5.64598 13.6103 6.3581 13.4737 7.04511C13.337 7.73213 12.9997 8.36319 12.5044 8.8585C12.0091 9.35381 11.378 9.69112 10.691 9.82778C10.004 9.96444 9.29186 9.8943 8.64471 9.62624C7.99755 9.35818 7.44442 8.90423 7.05525 8.32181C6.66609 7.73939 6.45838 7.05464 6.45838 6.35417C6.45838 5.41486 6.83152 4.51402 7.49571 3.84983C8.1599 3.18564 9.06073 2.8125 10 2.8125ZM10 1.5625C9.05234 1.5625 8.12592 1.84353 7.33794 2.37004C6.54995 2.89656 5.93579 3.64491 5.57312 4.52048C5.21045 5.39604 5.11556 6.35948 5.30045 7.28897C5.48533 8.21847 5.9417 9.07226 6.61182 9.74239C7.28195 10.4125 8.13574 10.8689 9.06524 11.0538C9.99473 11.2387 10.9582 11.1438 11.8337 10.7811C12.7093 10.4184 13.4577 9.80426 13.9842 9.01627C14.5107 8.22829 14.7917 7.30187 14.7917 6.35417C14.7917 5.08334 14.2869 3.86456 13.3883 2.96595C12.4897 2.06733 11.2709 1.5625 10 1.5625Z"
                fill="url(#paint0_linear_5373_12085)" />
              <path
                d="M10 11.1465C11.7676 11.1484 13.4621 11.8514 14.712 13.1012C15.9618 14.3511 16.6648 16.0456 16.6667 17.8132H17.9167C17.9167 15.7135 17.0826 13.6999 15.598 12.2152C14.1133 10.7306 12.0997 9.89648 10 9.89648C7.90041 9.89648 5.88678 10.7306 4.40211 12.2152C2.91745 13.6999 2.08337 15.7135 2.08337 17.8132H3.33337C3.3353 16.0456 4.0383 14.3511 5.28813 13.1012C6.53795 11.8514 8.23252 11.1484 10 11.1465ZM2.08337 17.8132H3.33337C3.33337 17.9789 3.26753 18.1379 3.15032 18.2551C3.03311 18.3723 2.87413 18.4382 2.70837 18.4382C2.54261 18.4382 2.38364 18.3723 2.26643 18.2551C2.14922 18.1379 2.08337 17.9789 2.08337 17.8132ZM16.6667 17.8132H17.9167C17.9167 17.9789 17.8509 18.1379 17.7336 18.2551C17.6164 18.3723 17.4575 18.4382 17.2917 18.4382C17.1259 18.4382 16.967 18.3723 16.8498 18.2551C16.7326 18.1379 16.6667 17.9789 16.6667 17.8132Z"
                fill="url(#paint1_linear_5373_12085)" />
  <defs>
                <linearGradient id="paint0_linear_5373_12085" x1="5.20837" y1="6.35417" x2="14.7917" y2="6.35417"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
    </linearGradient>
                <linearGradient id="paint1_linear_5373_12085" x1="2.08337" y1="14.1673" x2="17.9167" y2="14.1673"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
    </linearGradient>
  </defs>
</svg>
            <div class="info-header">
                <span class="info-label">性别/年龄/工龄</span>
              <span class="info-value">{{ getGenderText(talent.sex) }}/{{ talent.age }}岁/{{ talent.work_years }}年</span>
            </div>
            </div>
          
          <div class="info-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M9.7538 3.17556C9.83162 3.1422 9.91539 3.125 10.0001 3.125C10.0847 3.125 10.1685 3.1422 10.2463 3.17556L18.9963 6.92556C19.0452 6.94713 19.0913 6.97441 19.1338 7.00681L19.1663 7.03431C19.1862 7.05054 19.2046 7.06853 19.2213 7.08806L19.2363 7.10681C19.2788 7.15681 19.3101 7.21306 19.3326 7.27181L19.3426 7.30056C19.3505 7.32341 19.3567 7.3468 19.3613 7.37056L19.3651 7.38806L19.3688 7.40931C19.372 7.43127 19.3741 7.45338 19.3751 7.47556V11.2506C19.3753 11.4067 19.3171 11.5574 19.2119 11.6728C19.1067 11.7882 18.9621 11.86 18.8065 11.8742C18.651 11.8883 18.4958 11.8436 18.3715 11.749C18.2472 11.6544 18.1629 11.5167 18.1351 11.3631L18.1251 11.2506V8.44681L15.6251 9.51806V15.4331C15.6252 15.5161 15.6088 15.5983 15.5768 15.6749C15.5449 15.7515 15.4979 15.821 15.4388 15.8793C15.1426 16.1718 14.6188 16.5906 13.9026 17.0068C12.7051 17.7043 11.3913 18.1256 10.0001 18.1256C8.6088 18.1256 7.29505 17.7043 6.09755 17.0068C5.54242 16.6935 5.02668 16.3149 4.5613 15.8793C4.46634 15.7859 4.40372 15.6646 4.38255 15.5331L4.37505 15.4331V9.51931L1.0038 8.07556C0.900634 8.03163 0.811183 7.96075 0.744829 7.87036C0.678474 7.77996 0.637661 7.67338 0.626668 7.56179C0.615675 7.45019 0.634907 7.3377 0.682347 7.2361C0.729788 7.13449 0.803689 7.04752 0.896304 6.98431L1.0038 6.92556L9.7538 3.17556ZM14.3751 10.0543L10.2463 11.8256C10.1685 11.8589 10.0847 11.8761 10.0001 11.8761C9.91539 11.8761 9.83162 11.8589 9.7538 11.8256L5.62505 10.0543V15.1543L5.7638 15.2693C6.0438 15.4931 6.3663 15.7168 6.7263 15.9268C7.7463 16.5218 8.8513 16.8756 10.0001 16.8756C11.1476 16.8756 12.2538 16.5218 13.2751 15.9268C13.5438 15.7693 13.7926 15.6043 14.0188 15.4368L14.3288 15.1943L14.3751 15.1531V10.0543ZM10.0001 4.42931L2.83505 7.50056L10.0001 10.5706L17.1638 7.50056L10.0001 4.42931Z"
                fill="url(#paint0_linear_5373_12094)" />
  <defs>
                <linearGradient id="paint0_linear_5373_12094" x1="0.623657" y1="10.6253" x2="19.3751" y2="10.6253"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
    </linearGradient>
  </defs>
</svg>
            <div class="info-header">
              <span class="info-label">毕业院校/学历</span>
            <span class="info-value">{{ talent.school }}/{{ getEducationLevel(talent.education_level) }}</span>
            </div>
            </div>
          
          <div class="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M16 4.96143H12.9998V3.98137C12.9998 3.44144 12.5497 3 12.0001 3H8.00021C7.7351 3.00078 7.48107 3.10443 7.29364 3.28832C7.1062 3.4722 7.0006 3.72136 6.9999 3.98137V4.96176H4.00029C3.47041 4.96323 2.96265 5.17025 2.58788 5.53762C2.2131 5.90499 2.00176 6.40287 2 6.92254L2 15.0389C2.00167 15.5586 2.21298 16.0566 2.58776 16.424C2.96254 16.7915 3.47036 16.9985 4.00029 17H16.0004C16.5302 16.9984 17.0378 16.7912 17.4125 16.4238C17.7871 16.0564 17.9983 15.5585 18 15.0389V6.92254C17.9983 6.40281 17.787 5.90485 17.4122 5.53741C17.0375 5.16997 16.5296 4.9629 15.9997 4.96143H16ZM8.00021 4.47124C8.00021 4.20127 8.2251 3.98104 8.50003 3.98104H11.5003C11.7746 3.98104 12.0001 4.20127 12.0001 4.47124V4.96143H8.00021V4.47124ZM2.99998 6.92254C3.00095 6.6627 3.10667 6.41379 3.29407 6.23012C3.48148 6.04645 3.73535 5.94293 4.00029 5.94215H16.0004C16.2651 5.94319 16.5187 6.04683 16.7058 6.23048C16.893 6.41414 16.9985 6.6629 16.9994 6.92254V9.37449H2.99998V6.92254ZM10.8497 10.3559C10.9254 10.5028 11.0001 10.6743 11.0001 10.8461C10.9993 11.106 10.8936 11.355 10.7062 11.5387C10.5188 11.7224 10.2648 11.826 9.99983 11.8268C9.73484 11.8261 9.4809 11.7225 9.29352 11.5388C9.10614 11.355 9.00056 11.106 8.99985 10.8461C8.99985 10.6743 9.0499 10.5025 9.15 10.3552H10.8497V10.3559ZM16.0004 16.0193H3.99962C3.73475 16.0185 3.48094 15.915 3.29364 15.7313C3.10635 15.5476 3.00077 15.2987 2.99998 15.0389V10.3559H8.07495C8.0239 10.5144 7.99868 10.6798 8.00021 10.8461C8.00188 11.3657 8.21309 11.8635 8.58773 12.231C8.96237 12.5984 9.47001 12.8055 9.99983 12.8072C10.5298 12.8057 11.0376 12.5986 11.4124 12.2312C11.7871 11.8637 11.9985 11.3658 12.0001 10.8461C12.0001 10.6743 11.9748 10.5025 11.9251 10.3559H17V15.0386C16.9993 15.2985 16.8937 15.5475 16.7064 15.7313C16.519 15.915 16.265 16.0186 16 16.0193H16.0004Z"
                fill="url(#paint0_linear_5373_12102)" />
  <defs>
                <linearGradient id="paint0_linear_5373_12102" x1="2" y1="10" x2="18" y2="10"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
    </linearGradient>
  </defs>
</svg>
            <div class="info-header">
            <span class="info-label">面试岗位</span>
            <span class="info-value">{{ talent.interview_position }}</span>
            </div>
          </div>
          
          <div class="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_5373_12110)">
                <path
                  d="M11.7638 16C10.7315 16 9.39885 15.3124 8.46262 14.7353C7.20883 13.9627 5.85814 12.8939 4.65926 11.7258L4.65494 11.7215L4.27427 11.3407C3.10614 10.142 2.03738 8.79117 1.26467 7.53738C0.687744 6.60115 0 5.26848 0 4.23622C0 3.13158 0.78992 1.9591 1.12954 1.50634C1.39453 1.15299 2.32038 0 3.10704 0C3.43008 0 3.77795 0.211424 4.23514 0.685568C4.63952 1.1048 5.02755 1.62595 5.28182 1.98931C5.62336 2.47715 5.93917 2.98794 6.17126 3.42765C6.54704 4.13955 6.59053 4.44483 6.59053 4.61254C6.59053 4.95101 6.41373 5.24458 6.06515 5.48502C5.83562 5.64333 5.5601 5.76253 5.29366 5.87786C5.11395 5.95558 4.82698 6.07965 4.71754 6.16691C4.75574 6.32864 4.92262 6.71923 5.37373 7.38147C5.79405 7.99853 6.33757 8.66726 6.82858 9.17152C7.33274 9.66246 8.00138 10.206 8.61862 10.6264C9.28067 11.0772 9.67126 11.2442 9.83312 11.2825C9.92029 11.173 10.0444 10.8861 10.1222 10.7064C10.2374 10.4399 10.3566 10.1644 10.515 9.93485C10.7555 9.58627 11.049 9.40957 11.3875 9.40957C11.5552 9.40957 11.8605 9.45302 12.5725 9.82874C13.0121 10.0608 13.523 10.3766 14.0108 10.7182C14.3741 10.9725 14.8952 11.3606 15.3146 11.7649C15.7886 12.222 16 12.5699 16 12.893C16 13.6796 14.8471 14.6055 14.4938 14.8705C14.0409 15.2101 12.8684 16 11.7638 16ZM5.32077 11.0512C6.47088 12.1716 7.76253 13.1942 8.95834 13.9311C10.1176 14.6455 11.1402 15.0553 11.7638 15.0553C12.3193 15.0553 13.1112 14.716 13.8822 14.1479C14.2203 13.8988 14.5279 13.6214 14.7485 13.3668C14.9555 13.1278 15.0312 12.9719 15.0504 12.909C14.9704 12.7371 14.4953 12.1998 13.3863 11.4348C12.9512 11.1347 12.5015 10.8589 12.1199 10.6583C11.6407 10.4064 11.441 10.3628 11.3952 10.3557C11.3775 10.3679 11.3253 10.4115 11.2459 10.5445C11.1571 10.6934 11.0717 10.8908 10.9892 11.0816C10.8876 11.3166 10.7825 11.5596 10.6536 11.7556C10.4439 12.0745 10.1865 12.2362 9.88858 12.2364C9.88317 12.2364 9.87757 12.2363 9.87181 12.2361C9.72685 12.2331 9.28531 12.2237 8.08669 11.4074C7.42502 10.9565 6.70643 10.3721 6.16474 9.84378L6.15626 9.83539C5.628 9.29354 5.04358 8.57504 4.59283 7.91344C3.77642 6.71482 3.76698 6.27331 3.7639 6.12826C3.75741 5.82486 3.91757 5.56294 4.23971 5.34963C4.4367 5.21923 4.68166 5.11331 4.91853 5.01078C5.10938 4.92829 5.30666 4.84288 5.45562 4.75418C5.58861 4.67491 5.63235 4.62262 5.64442 4.60486C5.63728 4.55914 5.59376 4.35946 5.34186 3.88022C5.14125 3.49866 4.86544 3.04886 4.56538 2.61392C3.80035 1.50483 3.26301 1.0297 3.09117 0.949728C3.02822 0.968992 2.87232 1.04467 2.63331 1.25168C2.37869 1.47219 2.10128 1.7799 1.85226 2.11795C1.28406 2.88893 0.944896 3.6808 0.944896 4.23629C0.944896 4.85984 1.35459 5.88237 2.06902 7.04176C2.80598 8.23757 3.82861 9.52922 4.94886 10.6793L5.32077 11.0512Z"
                  fill="url(#paint0_linear_5373_12110)" />
  </g>
  <defs>
                <linearGradient id="paint0_linear_5373_12110" x1="0" y1="8" x2="16" y2="8"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
    </linearGradient>
    <clipPath id="clip0_5373_12110">
                  <rect width="16" height="16" fill="white" />
    </clipPath>
  </defs>
</svg>
            <div class="info-header">
            <span class="info-label">电话号码</span>
            <span class="info-value">{{ talent.mobile }}</span>
            </div>
        </div>
        
          <div class="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M14.5073 2.44141H3.46118C2.15161 2.44141 1.08813 3.50664 1.08813 4.81445V13.1746C1.08813 14.4367 2.07778 15.4686 3.32231 15.5406C3.36802 15.5441 3.41548 15.5477 3.46294 15.5477H14.509C14.9749 15.5477 15.4073 15.4105 15.7747 15.1785C15.8731 15.117 15.9663 15.0484 16.0524 14.9729C16.5604 14.5369 16.8821 13.8918 16.8821 13.1729V4.81621C16.8821 3.50664 15.8168 2.44141 14.5073 2.44141ZM11.9356 8.91367L15.9329 5.67754V12.1516L11.9356 8.91367ZM3.46118 3.39238H14.5073C15.1788 3.39238 15.743 3.86172 15.8924 4.4875L11.1815 8.30195L10.4274 8.91367L9.74888 9.46387C9.30767 9.8207 8.66782 9.8207 8.22661 9.46387L7.5481 8.91367L6.79399 8.30195L2.07778 4.48574C2.2272 3.8582 2.79146 3.39238 3.46118 3.39238ZM2.03735 5.67402L6.03638 8.91367L2.03735 12.1533V5.67402ZM15.562 14.1309C15.4547 14.2504 15.3264 14.3488 15.184 14.4262C14.9819 14.5369 14.7516 14.6002 14.5073 14.6002H3.46118C3.26782 14.6002 3.08325 14.5598 2.9145 14.4895C2.76685 14.4279 2.63149 14.3418 2.51196 14.2363C2.26411 14.0148 2.09536 13.709 2.04966 13.3645L6.79048 9.52539L7.62544 10.2021C8.01919 10.5203 8.50259 10.6803 8.98423 10.6803C9.46763 10.6803 9.94927 10.5203 10.343 10.2021L11.178 9.52539L15.9153 13.3627C15.8801 13.6545 15.7518 13.9199 15.562 14.1309Z"
                fill="url(#paint0_linear_5373_12118)" />
  <defs>
                <linearGradient id="paint0_linear_5373_12118" x1="1.08813" y1="8.99453" x2="16.8821" y2="8.99453"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
    </linearGradient>
  </defs>
</svg>
            <div class="info-header">
            <span class="info-label">电子邮箱</span>
            <span class="info-value">{{ talent.email }}</span>
            </div>
          </div>
          </div>
          
        <!-- 查看简历按钮 -->
        <div class="resume-section">
          <button class="resume-btn" @click="showResumePreview">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
              <path
                d="M14.8854 11H11.5419C10.6193 11 9.92433 11.6901 9.92433 12.6059V16H1.81391C1.20538 16 0.800049 15.6 0.800049 15V1C0.800049 0.4 1.20538 0 1.81338 0H13.9739C14.5825 0 14.9878 0.4 14.8859 1V11H14.8854ZM8.35474 10H5.33338C5.03099 10 4.82938 10.2 4.82938 10.5003C4.82938 10.8 5.03099 11 5.33338 11H8.35474C8.65713 11 8.85874 10.8 8.85874 10.5003C8.85874 10.2 8.65713 10 8.35474 10ZM7.3478 12H5.33285C5.03046 12 4.82885 12.2 4.82885 12.5003C4.82885 12.8 5.03045 13 5.33286 13H7.34727C7.64914 13 7.85074 12.8 7.85074 12.5003C7.85072 12.2 7.64911 12 7.34724 12H7.3478ZM10.9318 14.6667V12.6059C10.9318 12.2421 11.1771 12 11.5424 12H13.6182L10.9323 14.6667H10.9318ZM9.26138 5.4C9.66458 5 9.86564 4.49973 9.86564 4C9.86564 2.90027 8.95899 2 7.85125 2C6.74352 2 5.8363 2.90027 5.8363 4C5.8363 4.49973 6.03789 5 6.44056 5.4C5.95487 5.6383 5.5461 6.00856 5.26106 6.46838C4.97602 6.9282 4.82624 7.459 4.82886 8C4.82886 8.30027 5.03046 8.49973 5.33285 8.49973C5.63472 8.49973 5.83631 8.30027 5.83631 8C5.83631 6.90027 6.74299 6 7.85072 6C8.95899 6 9.86511 6.90027 9.86511 8C9.86511 8.30027 10.0667 8.49973 10.3691 8.49973C10.671 8.49973 10.8726 8.30027 10.8726 8C10.8753 7.45899 10.7255 6.92816 10.4405 6.46833C10.1554 6.00849 9.7466 5.63824 9.26086 5.4H9.26138ZM7.85125 5C7.24699 5 6.84431 4.6 6.84431 4C6.84431 3.4 7.24697 3 7.85125 3C8.45553 3 8.85872 3.4 8.85872 4C8.85872 4.6 8.45552 5 7.85125 5Z"
                fill="white" />
            </svg>
            <span>查看简历</span>
          </button>
            </div>
          
        <!-- 评分区域 -->
        <div class="scoring-section">
          <div class="overall-score">
            <span class="score-label">候选人推荐指数</span>
            <span class="score-value">{{ score.totalScore || 95 }}分</span>
          </div>
          
          <div class="score-items">
            <div class="score-item">
              <div class="score-item-header">
                <span class="score-item-label">沟通表达能力</span>
                <span class="score-item-value">{{ score.communicationScore }}分</span>
              </div>
              <div class="score-bar">
                <div class="score-fill" :style="{ width: score.communicationScore + '%' }"></div>
              </div>
            </div>
          
            <div class="score-item">
              <div class="score-item-header">
                <span class="score-item-label">问题解决能力与逻辑思维能力</span>
                <span class="score-item-value">{{ score.logicScore }}分</span>
              </div>
              <div class="score-bar">
                <div class="score-fill" :style="{ width: score.logicScore + '%' }"></div>
              </div>
            </div>
          
            <div class="score-item">
              <div class="score-item-header">
                <span class="score-item-label">专业能力</span>
                <span class="score-item-value">{{ score.skillScore }}分</span>
              </div>
              <div class="score-bar">
                <div class="score-fill" :style="{ width: score.skillScore + '%' }"></div>
              </div>
            </div>
          
            <div class="score-item">
              <div class="score-item-header">
                <span class="score-item-label">抗压能力</span>
                <span class="score-item-value">{{ score.stressScore }}分</span>
              </div>
              <div class="score-bar">
                <div class="score-fill" :style="{ width: score.stressScore + '%' }"></div>
              </div>
            </div>
          
          
            <div class="score-item">
              <div class="score-item-header">
                <span class="score-item-label">成长潜力</span>
                <span class="score-item-value">{{ score.potentialScore || 90 }}分</span>
              </div>
              <div class="score-bar">
                <div class="score-fill" :style="{ width: score.potentialScoree || 90 + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="center">
        <!-- 面试总结 -->
        <div class="interview-summary">
          <div class="summary-header">
            <span class="summary-title">面试总结</span>
          </div>
          <div class="summary-content">
            <p class="summary-text">{{ score.feedbackText }}</p>
          </div>
        </div>
        
        <!-- 面试记录 -->
        <div class="interview-record">
          <div class="interview-record-header">
            <span class="interviewresult">面试记录</span>
          </div>

          <div class="frame-1" style="flex: 1; overflow-y: auto; width: auto">
          <img class="vector-1" src="./assets/img/vector-10.svg" />
          <div class="center-result" v-for="(item, index) in questions" :key="index">
              <div class="question-section">
                <div class="question-number">{{ index + 1 }}</div>
                <div class="question-content">
                  <p class="question0">问题</p>
            <p class="question1">{{ item.question }}</p>
                </div>
              </div>
              <div class="divider"></div>
              <div class="answer-section">
            <p class="answer0">回答</p>
            <p class="answer1">{{ item.answer }}</p>
              </div>
              <div class="advice-section">
            <p class="advice0">面试官建议</p>
            <p class="advice1">{{ item.advice }}</p>
          </div>
        </div>
      </div>
          </div>
          </div>
          
      <div class="right" ref="rightElement" v-show="false">
        <div class="right-date">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10.8125 1C11.0714 1 11.2812 1.20986 11.2812 1.46875V2.25H13.5938C14.3704 2.25 15 2.87959 15 3.65625V13.5938C15 14.3704 14.3704 15 13.5938 15H2.40625C1.62959 15 1 14.3704 1 13.5938V3.65625C1 2.87959 1.62959 2.25 2.40625 2.25H4.71875V1.46875C4.71875 1.20986 4.92861 1 5.1875 1C5.44639 1 5.65625 1.20986 5.65625 1.46875V2.25H10.3438V1.46875C10.3438 1.20986 10.5536 1 10.8125 1ZM14.0625 6.46875H1.9375V13.5938C1.9375 13.8526 2.14736 14.0625 2.40625 14.0625H13.5938C13.8526 14.0625 14.0625 13.8526 14.0625 13.5938V6.46875ZM8.9375 11C9.19639 11 9.40625 11.2099 9.40625 11.4688C9.40625 11.7276 9.19639 11.9375 8.9375 11.9375H3.3125C3.05361 11.9375 2.84375 11.7276 2.84375 11.4688C2.84375 11.2099 3.05361 11 3.3125 11H8.9375ZM12.6875 11C12.9464 11 13.1562 11.2099 13.1562 11.4688C13.1562 11.7276 12.9464 11.9375 12.6875 11.9375H10.8125C10.5536 11.9375 10.3438 11.7276 10.3438 11.4688C10.3438 11.2099 10.5536 11 10.8125 11H12.6875ZM5.1875 8.59375C5.44639 8.59375 5.65625 8.80361 5.65625 9.0625C5.65625 9.32139 5.44639 9.53125 5.1875 9.53125H3.3125C3.05361 9.53125 2.84375 9.32139 2.84375 9.0625C2.84375 8.80361 3.05361 8.59375 3.3125 8.59375H5.1875ZM8.9375 8.59375C9.19639 8.59375 9.40625 8.80361 9.40625 9.0625C9.40625 9.32139 9.19639 9.53125 8.9375 9.53125H7.0625C6.80361 9.53125 6.59375 9.32139 6.59375 9.0625C6.59375 8.80361 6.80361 8.59375 7.0625 8.59375H8.9375ZM12.6875 8.59375C12.9464 8.59375 13.1562 8.80361 13.1562 9.0625C13.1562 9.32139 12.9464 9.53125 12.6875 9.53125H10.8125C10.5536 9.53125 10.3438 9.32139 10.3438 9.0625C10.3438 8.80361 10.5536 8.59375 10.8125 8.59375H12.6875ZM4.71875 3.1875H2.40625C2.14736 3.1875 1.9375 3.39736 1.9375 3.65625V5.53125H14.0625V3.65625C14.0625 3.39736 13.8526 3.1875 13.5938 3.1875H11.2812V3.96875C11.2812 4.22764 11.0714 4.4375 10.8125 4.4375C10.5536 4.4375 10.3438 4.22764 10.3438 3.96875V3.1875H5.65625V3.96875C5.65625 4.22764 5.44639 4.4375 5.1875 4.4375C4.92861 4.4375 4.71875 4.22764 4.71875 3.96875V3.1875Z" fill="url(#paint0_linear_5373_12359)"/>
  <defs>
    <linearGradient id="paint0_linear_5373_12359" x1="1" y1="8" x2="15" y2="8" gradientUnits="userSpaceOnUse">
      <stop stop-color="#62AFFF"/>
      <stop offset="1" stop-color="#9C41FF"/>
    </linearGradient>
  </defs>
</svg>
          <span class="date-text">{{ formatTime(talent.interview_time) }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M8.2544 8.23507V5.47739C8.2544 5.21374 7.97358 5 7.6272 5C7.28082 5 7 5.21374 7 5.47739V8.4328L7.00004 8.43411C7.00006 8.44154 7.00029 8.44897 7.00077 8.45639C7.00102 8.46022 7.00148 8.46401 7.00186 8.46783C7.00224 8.47176 7.00253 8.4757 7.00303 8.47962C7.00364 8.48441 7.00447 8.48913 7.00527 8.49388C7.00575 8.49679 7.00617 8.4997 7.00673 8.50261C7.00771 8.50774 7.00891 8.5128 7.01012 8.51787C7.01073 8.5204 7.01125 8.52295 7.0119 8.52548C7.01321 8.5306 7.01474 8.53566 7.01629 8.54072C7.01704 8.54324 7.01775 8.54574 7.01857 8.54825C7.02015 8.55315 7.02193 8.55799 7.02373 8.56283C7.02473 8.56552 7.02567 8.56821 7.02674 8.5709C7.02852 8.5754 7.03046 8.57984 7.03241 8.58428C7.03374 8.58732 7.03504 8.59036 7.03646 8.59338C7.03832 8.59736 7.04033 8.60129 7.04234 8.60522C7.04409 8.60867 7.04583 8.61211 7.04769 8.61553C7.04955 8.61895 7.05154 8.62231 7.05348 8.6257C7.05572 8.62957 7.05795 8.63343 7.06034 8.63725C7.06213 8.64013 7.06404 8.64297 7.0659 8.64581C7.06866 8.65001 7.07142 8.6542 7.07434 8.65835C7.07608 8.6608 7.0779 8.66322 7.0797 8.66566C7.08294 8.67007 7.08618 8.67446 7.08963 8.67879C7.09134 8.68095 7.09314 8.68307 7.0949 8.6852C7.09855 8.68965 7.10221 8.69409 7.10608 8.69849C7.10792 8.70057 7.10986 8.70261 7.11175 8.70468C7.11566 8.70896 7.11954 8.71322 7.12364 8.71742C7.12588 8.71971 7.12824 8.72194 7.13054 8.7242C7.13445 8.72805 7.13834 8.73192 7.14242 8.73571C7.14547 8.73852 7.14867 8.74126 7.1518 8.74403C7.15534 8.74715 7.15877 8.7503 7.16242 8.75335C7.16811 8.75814 7.17401 8.76279 7.17994 8.76739C7.18122 8.76838 7.18241 8.76941 7.18371 8.7704L9.92931 10.8602C10.0518 10.9534 10.2123 11 10.3728 11C10.5333 11 10.6938 10.9534 10.8163 10.8602C11.0612 10.6737 11.0612 10.3715 10.8163 10.185L8.2544 8.23507Z" fill="url(#paint0_linear_5373_12366)"/>
  <path d="M14.4497 5.27512C14.0971 4.44151 13.5924 3.69295 12.9498 3.05025C12.307 2.40754 11.5585 1.90289 10.7249 1.55031C9.86153 1.18514 8.94477 1 8 1C7.05523 1 6.13847 1.18514 5.27512 1.55031C4.44151 1.90291 3.69295 2.40756 3.05025 3.05025C2.40754 3.69294 1.90289 4.44149 1.55031 5.27512C1.18514 6.13847 1 7.05523 1 8C1 8.94477 1.18514 9.86153 1.55031 10.7249C1.90291 11.5585 2.40756 12.307 3.05025 12.9497C3.69294 13.5924 4.44149 14.0971 5.27512 14.4497C6.13847 14.8149 7.05523 15 8 15C8.94477 15 9.86153 14.8149 10.7249 14.4497C11.5585 14.0971 12.307 13.5924 12.9497 12.9498C13.5924 12.3071 14.0971 11.5585 14.4497 10.7249C14.8149 9.86153 15 8.94477 15 8C15 7.05523 14.8149 6.13847 14.4497 5.27512ZM8 13.9231C4.734 13.9231 2.07692 11.266 2.07692 8C2.07692 4.734 4.734 2.07692 8 2.07692C11.266 2.07692 13.9231 4.734 13.9231 8C13.9231 11.266 11.266 13.9231 8 13.9231Z" fill="url(#paint1_linear_5373_12366)"/>
  <defs>
    <linearGradient id="paint0_linear_5373_12366" x1="7" y1="8" x2="11" y2="8" gradientUnits="userSpaceOnUse">
      <stop stop-color="#62AFFF"/>
      <stop offset="1" stop-color="#9C41FF"/>
    </linearGradient>
    <linearGradient id="paint1_linear_5373_12366" x1="1" y1="8" x2="15" y2="8" gradientUnits="userSpaceOnUse">
      <stop stop-color="#62AFFF"/>
      <stop offset="1" stop-color="#9C41FF"/>
    </linearGradient>
  </defs>
</svg>
<span class="date-text">{{ talent.interview_duration }}分钟</span>
        </div>
        <div class="right-header" >
          <span class="right-title">面试过程中截图</span>
            </div>
        <div class="timeline-wrapper">
          <div class="timeline-line"></div>
          <div class="timeline-items">
            <div v-if="timelineItems.length === 0" class="no-timeline-data">
              <p>暂无面试截图数据</p>
            </div>
            <div v-for="item in timelineItems" :key="item.id" class="timeline-item">
              <div class="timeline-dot">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8.2544 8.23507V5.47739C8.2544 5.21374 7.97358 5 7.6272 5C7.28082 5 7 5.21374 7 5.47739V8.4328L7.00004 8.43411C7.00006 8.44154 7.00029 8.44897 7.00077 8.45639C7.00102 8.46022 7.00148 8.46401 7.00186 8.46783C7.00224 8.47176 7.00253 8.4757 7.00303 8.47962C7.00364 8.48441 7.00447 8.48913 7.00527 8.49388C7.00575 8.49679 7.00617 8.4997 7.00673 8.50261C7.00771 8.50774 7.00891 8.5128 7.01012 8.51787C7.01073 8.5204 7.01125 8.52295 7.0119 8.52548C7.01321 8.5306 7.01474 8.53566 7.01629 8.54072C7.01704 8.54324 7.01775 8.54574 7.01857 8.54825C7.02015 8.55315 7.02193 8.55799 7.02373 8.56283C7.02473 8.56552 7.02567 8.56821 7.02674 8.5709C7.02852 8.5754 7.03046 8.57984 7.03241 8.58428C7.03374 8.58732 7.03504 8.59036 7.03646 8.59338C7.03832 8.59736 7.04033 8.60129 7.04234 8.60522C7.04409 8.60867 7.04583 8.61211 7.04769 8.61553C7.04955 8.61895 7.05154 8.62231 7.05348 8.6257C7.05572 8.62957 7.05795 8.63343 7.06034 8.63725C7.06213 8.64013 7.06404 8.64297 7.0659 8.64581C7.06866 8.65001 7.07142 8.6542 7.07434 8.65835C7.07608 8.6608 7.0779 8.66322 7.0797 8.66566C7.08294 8.67007 7.08618 8.67446 7.08963 8.67879C7.09134 8.68095 7.09314 8.68307 7.0949 8.6852C7.09855 8.68965 7.10221 8.69409 7.10608 8.69849C7.10792 8.70057 7.10986 8.70261 7.11175 8.70468C7.11566 8.70896 7.11954 8.71322 7.12364 8.71742C7.12588 8.71971 7.12824 8.72194 7.13054 8.7242C7.13445 8.72805 7.13834 8.73192 7.14242 8.73571C7.14547 8.73852 7.14867 8.74126 7.1518 8.74403C7.15534 8.74715 7.15877 8.7503 7.16242 8.75335C7.16811 8.75814 7.17401 8.76279 7.17994 8.76739C7.18122 8.76838 7.18241 8.76941 7.18371 8.7704L9.92931 10.8602C10.0518 10.9534 10.2123 11 10.3728 11C10.5333 11 10.6938 10.9534 10.8163 10.8602C11.0612 10.6737 11.0612 10.3715 10.8163 10.185L8.2544 8.23507Z" fill="url(#paint0_linear_5373_12229)"/>
                  <path d="M14.4497 5.27512C14.0971 4.44151 13.5924 3.69295 12.9498 3.05025C12.307 2.40754 11.5585 1.90289 10.7249 1.55031C9.86153 1.18514 8.94477 1 8 1C7.05523 1 6.13847 1.18514 5.27512 1.55031C4.44151 1.90291 3.69295 2.40756 3.05025 3.05025C2.40754 3.69294 1.90289 4.44149 1.55031 5.27512C1.18514 6.13847 1 7.05523 1 8C1 8.94477 1.18514 9.86153 1.55031 10.7249C1.90291 11.5585 2.40756 12.307 3.05025 12.9497C3.69294 13.5924 4.44149 14.0971 5.27512 14.4497C6.13847 14.8149 7.05523 15 8 15C8.94477 15 9.86153 14.8149 10.7249 14.4497C11.5585 14.0971 12.307 13.5924 12.9497 12.9498C13.5924 12.3071 14.0971 11.5585 14.4497 10.7249C14.8149 9.86153 15 8.94477 15 8C15 7.05523 14.8149 6.13847 14.4497 5.27512ZM8 13.9231C4.734 13.9231 2.07692 11.266 2.07692 8C2.07692 4.734 4.734 2.07692 8 2.07692C11.266 2.07692 13.9231 4.734 13.9231 8C13.9231 11.266 11.266 13.9231 8 13.9231Z" fill="url(#paint1_linear_5373_12229)"/>
                  <defs>
                    <linearGradient id="paint0_linear_5373_12229" x1="7" y1="8" x2="11" y2="8" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#62AFFF"/>
                      <stop offset="1" stop-color="#9C41FF"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear_5373_12229" x1="1" y1="8" x2="15" y2="8" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#62AFFF"/>
                      <stop offset="1" stop-color="#9C41FF"/>
                    </linearGradient>
                  </defs>
                </svg>
          </div>
              <div class="timeline-content">
                <span class="timeline-time">{{ formatTime(item.screenshot_time) }}</span>
                <img class="timeline-screenshot" :src="item.image_url" :alt="`Interview screenshot at ${formatTime(item.screenshot_time)}`" />
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 头像放大模态框 -->
    <div v-if="showAvatarModal" class="avatar-modal-overlay" @click="showAvatarModal = false">
      <div class="avatar-modal-content" @click.stop>
        <Avatar :src="avatarUrl" :char="talent.name" :size="200" :bgColor="'rgb(0, 113, 227)'" :alt="talent.name"
          class="avatar-modal-image" />
        <div class="avatar-modal-info">
          <h3>{{ talent.name }}</h3>
          <p>{{ talent.interview_position }}</p>
        </div>
        <button class="avatar-modal-close" @click="showAvatarModal = false">×</button>
      </div>
    </div>

    <!-- PDF简历预览弹窗 -->
    <div v-if="showResumeModal" class="resume-modal-overlay" @click="showResumeModal = false">
      <div class="resume-modal-content" @click.stop>
        <div class="resume-modal-header">
          <h3>{{ talent.name }} - 简历预览</h3>
          <div class="resume-modal-actions">
            <button class="resume-download-btn" @click="downloadResume">下载简历</button>
            <button class="resume-modal-close" @click="showResumeModal = false">×</button>
          </div>
        </div>
        <div class="resume-modal-body">
          <iframe v-if="talent.resume_url && isPdfFile(talent.resume_url)" :src="getPdfPreviewUrl(talent.resume_url)"
            class="resume-iframe" frameborder="0" type="application/pdf"></iframe>
          <div v-else-if="talent.resume_url && !isPdfFile(talent.resume_url)" class="resume-no-file">
            <p>该文件不是PDF格式，无法预览</p>
            <p>请点击下载按钮下载文件</p>
          </div>
          <div v-else class="resume-no-file">
            <p>暂无简历文件</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./assets/index.css";
import "./assets/vars.css";
import ProgressBar from '@/components/Progress/index.vue';
import Avatar from '@/components/Avatar.vue';
import { getTalentDetail, getInterviewResult, getInterviewResultList, favoriteTalent, generateFeedback } from '@/api/talent'
import { getAvatarUrl, isValidAvatarUrl } from '@/utils/avatar'

export default {
  components: {
    ProgressBar,
    Avatar
  },

  data() {
    return {
      id: null,
      talent: {},
      avatarUrl: '',
      rightBottomStyle: {
        width: '0px',
        height: '0px',
        borderRadius: '0px'
      },
      nickname: '',
      progress: 0,
      showPanel: false,
      showAvatarModal: false,
      showResumeModal: false,

      interviewSummary: "暂时没有总结生成",
      timelineItems: [],
      score: {
        skillScore: 90,
        stressScore: 91,
        communicationScore: 92,
        logicScore: 93,
        totalScore: 95,
        potentialScore: 90
      },
      questions: [
        {
          question: "没有检测到对话",
          answer: "没有检测到对话内容",
          advice: "没有检测到对话内容"
        },
       /*  {
          question: "请介绍一下你最擅长的技术领域和项目经验",
          answer: "我最擅长Java后端开发，有5年相关工作经验。在之前的公司参与过大型电商平台的架构设计和开发，负责订单系统和支付模块的核心开发工作，解决了高并发场景下的性能问题。",
          advice: "技术描述清晰，项目经验丰富，可进一步了解架构设计能力。"
        },
        {
          question: "为什么选择我们公司的Java开发工程师岗位？",
          answer: "贵公司在互联网金融领域有很强的技术积累，我非常认同公司的技术理念和发展方向。这个岗位的职责与我的职业规划非常匹配，希望能在这里发挥自己的专业能力。",
          advice: "对公司有一定了解，求职动机明确。"
        },
        {
          question: "你如何处理工作中的压力和挑战？",
          answer: "面对压力时，我会先冷静分析问题根源，拆解任务优先级，然后逐步解决。遇到技术难题会主动查阅资料或请教同事，保持积极的心态面对挑战。",
          advice: "有成熟的应对压力方法，具备良好的心态。"
        } */
      ],
      gaugeChart: null
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleChartResize);
    this.$nextTick(() => {
      this.getRightElement();
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleChartResize);
    if (this.gaugeChart) {
      this.gaugeChart.dispose();
    }
  },

  methods: {
    // 获取教育水平文本
    getEducationLevel(level) {
      const educationMap = {
        0: '未知',
        1: '初中',
        2: '高中',
        3: '大专',
        4: '本科',
        5: '硕士',
        6: '博士'
      };
      return educationMap[level] || '未知学历';
    },

    // 获取性别文本
    getGenderText(sex) {
      const genderMap = {
        1: '男',
        2: '女'
      };
      return genderMap[sex] || '性别未知';
    },

    // 格式化时间戳为日期时间（支持秒/毫秒，默认到秒）
    formatTime(timestamp, isShort = false) {
      if (!timestamp) return '未知时间';
      const tsNumber = Number(timestamp);
      const isMillis = tsNumber > 1e12; // > ~2001-09-09 in ms
      const date = new Date(isMillis ? tsNumber : tsNumber * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return isShort
        ? `${hours}:${minutes}`
        : `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 判断是否为PDF文件
    isPdfFile(url) {
      if (!url) return false;
      // 检查URL是否以.pdf结尾（不区分大小写）
      return /\.pdf$/i.test(url);
    },

    // 显示简历预览弹窗
    showResumePreview() {
      if (this.talent.resume_url) {
        if (this.isPdfFile(this.talent.resume_url)) {
          this.showResumeModal = true;
        } else {
          this.$message.warning('该文件不是PDF格式，无法预览，请直接下载');
        }
      } else {
        this.$message.warning('该候选人暂无简历');
      }
    },

    // 获取PDF预览URL，避免自动下载
    getPdfPreviewUrl(url) {
      if (!url) return '';
      
      // 由于项目已经配置了PDF代理，直接使用代理URL
      // 代理配置已经移除了content-disposition头，应该可以正常预览
      if (url.includes('ai-interview.obs.cn-southwest-2.myhuaweicloud.com')) {
        // 将原始URL转换为代理URL
        const proxyUrl = url.replace('https://ai-interview.obs.cn-southwest-2.myhuaweicloud.com', '/pdf-proxy');
        return proxyUrl;
      }
      
      // 如果不是华为云URL，直接返回原URL
      return url;
    },

    // 下载简历
    downloadResume() {
      if (this.talent.resume_url) {
        window.open(this.talent.resume_url, '_blank');
      } else {
        this.$message.warning('该候选人暂无简历');
      }
    },

    // 导出面试记录
    exportInterview() {
      this.progress = 0;
      const timer = setInterval(() => {
        this.progress += 10;
        if (this.progress >= 100) {
          this.progress = 100;
          clearInterval(timer);
          this.$message.success('面试记录导出成功');
        }
      }, 300);
    },

    getRightElement() {
      const rightElement = this.$refs.rightElement;
      if (rightElement) {
        const width = rightElement.clientWidth;
        const height = rightElement.clientHeight;
        const computedStyle = window.getComputedStyle(rightElement);
        
        return {
          width,
          height,
          borderRadius: computedStyle.borderRadius,
          borderWidth: computedStyle.borderWidth
        }
      }
    },

    handleChartResize() {
      if (this.gaugeChart) {
        this.gaugeChart.resize();
      }
    },

    navigateToProfile() {
      this.$router.push('/store/dashboard/profile');
    },

    getnickname() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo && userInfo.nickname) {
        this.nickname = userInfo.nickname;
      }
    },

    // 获取头像URL
    getAvatarUrl(id) {
      return getAvatarUrl(id);
    },

    // 设置候选人头像
    setCandidateAvatar() {
      if (this.talent && this.talent.avatar) {
        // 使用头像工具函数处理头像URL
        const processedAvatarUrl = getAvatarUrl(this.talent);
        if (processedAvatarUrl && isValidAvatarUrl(processedAvatarUrl)) {
          this.avatarUrl = processedAvatarUrl;
        } else {
          this.avatarUrl = null; // Avatar组件会自动显示姓名首字母
        }
      } else {
        // 没有头像时，Avatar组件会显示姓名首字母
        this.avatarUrl = null;
      }
    },


    async getFeedBack(){
      generateFeedback({
        interviewId: this.talent.interview_id,
      }).then(resp => {
        this.score = resp.data.data
      })
    },
    // 获取面试对话内容
    async getInterviewContent() {
      try {
        const { data } = await getInterviewResult({ interviewId: this.talent.interview_id });
        if (data.code === 1 && data.data) {
          // 解析对话内容
          if (data.data.answer_content_desc) {
            try {
              const conversationArray = JSON.parse(data.data.answer_content_desc);
              this.questions = this.parseConversationToQuestions(conversationArray);
            } catch (parseError) {
              console.warn('解析对话内容失败:', parseError);
              this.questions = [{
                question: "解析对话内容失败",
                answer: data.data.answer_content_desc,
                advice: "请检查数据格式"
              }];
            }
          }
          
          
          // 更新综合评分
          if (data.data.overall_score) {
            this.talent.evaluation_score = data.data.overall_score;
          }
          
          // 更新面试总结
          if (data.data.interview_summary && data.data.interview_summary.trim() !== '') {
            this.interviewSummary = data.data.interview_summary;
          } else {
            this.interviewSummary = '暂时没有总结生成';
          }
          
          // 获取面试截图时间线数据
          this.getInterviewTimeline();
        } else {
          console.warn('获取面试对话内容失败:', data.msg || '未知错误');
        }
      } catch (error) {
        console.error('获取面试对话内容失败:', error);
        this.$message.error('获取面试对话内容失败，请稍后重试');
      }
    },

    // 获取面试截图时间线数据
    async getInterviewTimeline() {
      try {
        const { data } = await getInterviewResultList({ interviewId: this.talent.interview_id });
        if (data.code === 1 && data.data && Array.isArray(data.data)) {
          this.timelineItems = data.data.map(item => ({
            id: item.id,
            screenshot_time: item.screenshot_time,
            image_url: item.image_url,
            create_time: item.create_time
          }));
        } else {
          console.warn('获取面试截图数据失败:', data.msg || '未知错误');
          this.timelineItems = [];
        }
      } catch (error) {
        console.error('获取面试截图数据失败:', error);
        this.timelineItems = [];
      }
    },

    // 格式化时长显示（mm:ss）
    formatDuration(seconds) {
      const safeSeconds = Number(seconds) || 0;
      const minutes = Math.floor(safeSeconds / 60);
      const remainingSeconds = Math.floor(safeSeconds % 60);
      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    },

    // 发送消息
    sendMessage() {
      console.log("发送消息给候选人:", this.talent);
      this.$router.push({
        name: "chating",
        query: { 
          jobId: this.talent.job_id, 
          targetUserId: this.talent.user_id 
        },
      });
    },

    // 解析对话数组为问题-回答格式
    parseConversationToQuestions(conversationArray) {
      const questions = [];
      
      for (let i = 0; i < conversationArray.length; i += 3) {
        if (i + 2 < conversationArray.length) {
          const question = conversationArray[i];
          const answer = conversationArray[i + 1];
          const advice = conversationArray[i + 2];
          
          // 过滤掉一些无效内容
          if (question && question !== "未完成回答" && question !== "介绍完了。") {
            questions.push({
              question: question,
              answer: answer || "无回答",
              advice: advice || "无建议"
            });
          }
        }
      }
      
      // 如果没有解析到有效问题，返回默认内容
      if (questions.length === 0) {
        return [{
          question: "暂无对话记录",
          answer: "面试过程中没有检测到有效对话",
          advice: "请检查面试记录是否完整"
        }];
      }
      
      return questions;
    },

    // 切换收藏状态
    async toggleCollect() {
      try {
        // 确保布尔值转换正确
        const currentStatus = Boolean(this.talent.is_collected);
        const newStatus = !currentStatus;

        // 调用收藏接口
        const response = await favoriteTalent({
          id: this.talent.user_id,
          isCollected: newStatus ? 1 : 0,
        });

        if (response.data.code === 1) {
          // 更新本地状态
          this.talent.is_collected = newStatus;
          this.$message.success(newStatus ? "收藏成功" : "取消收藏成功");
        } else {
          this.$message.error(
            newStatus
              ? "收藏失败"
              : "取消收藏失败: " + (response.msg || "操作失败")
          );
        }
      } catch (error) {
        console.error("收藏操作失败:", error);
        this.$message.error("收藏操作失败，请稍后重试");
      }
    },

  },

  async created() {
    this.id = this.$route.params.id;
    if (this.id) {
      try {
        const { data } = await getTalentDetail({ id: this.id });

        if (data.code === 1) {
          this.talent = data.data;

          console.log(data.data, 'data.data')
          
          // 如果有 interview_id，获取对话内容
          if (this.talent.interview_id) {
            await this.getInterviewContent();
            await this.getFeedBack();
          }
          // 设置候选人头像
          this.setCandidateAvatar();
        } else {
          this.$message.error('获取候选人详情失败: ' + (data.msg || '未知错误'));
        }
      } catch (error) {
        console.error('获取候选人详情失败:', error);
        this.$message.error('获取候选人详情失败，请稍后重试');
      }
    }
    this.getnickname();
  }
};
</script>

<style scoped>
/* 候选人卡片样式 */
.candidate-card {
  flex: 0 0 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  margin: 0;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  height: 80vh;
  min-height: 80vh;
  max-height: 80vh;
}

/* 返回按钮区域 */
.return-section {
  position: absolute;
  top: -60px;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 24px;
}

.return-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.return-icon:hover {
  transform: scale(1.1);
  opacity: 0.8;
}


/* 头像区域 */
.avatar-section {
  margin-bottom: 12px;
}

.avatar-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 3px solid rgba(126, 180, 235, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.avatar-container:hover {
  transform: scale(1.05);
  border-color: rgba(126, 180, 235, 0.6);
}

.candidate-avatar {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  transition: all 0.3s ease;
}

/* 姓名和认证区域 */
.name-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
}

.candidate-name {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0;
  text-align: center;
}

.verification-badge {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  height: 20px;
  opacity: 0.8;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.collect-btn,
.chat-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.collect-btn:hover,
.chat-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.collect-btn.active {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  color: white;
  border-color: transparent;
}


.star-icon,
.chat-icon {
  font-size: 16px;
}

/* 个人信息区域 */
.info-section {
  width: 100%;
  margin-bottom: 12px;
}

.info-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 6px;
  padding: 2px 0;
  gap: 8px;
}

.info-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
}

.info-icon {
  font-size: 16px;
  margin-right: 8px;
  width: 20px;
  text-align: center;
}

.info-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 2px;
  min-width: 70px;
}

.info-value {
  font-size: 12px;
  color: #333;
  flex: 1;
}

/* 查看简历按钮 */
.resume-section {
  width: 100%;
  margin-bottom: 12px;
}

.resume-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.resume-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
}

.resume-icon {
  font-size: 16px;
}

/* 评分区域 */
.scoring-section {
  width: 100%;
  box-sizing: border-box;
}

.overall-score {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 6px 0;
  border-bottom: 1px solid #e0e0e0;
}

.score-label {
  font-size: 14px;
  font-weight: 600;
  color: #656587;
}

.score-value {
  font-size: 16px;
  font-weight: bold;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.score-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.score-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.score-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.score-item-label {
  font-size: 12px;
  color: #333;
  font-weight: 500;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.score-item-value {
  font-size: 12px;
  color: #666;
  flex-shrink: 0;
  margin-left: 8px;
}

.score-bar {
  width: 100%;
  height: 4px;
  background: #f0f0f0;
  border-radius: 2px;
  overflow: hidden;
  max-width: 100%;
  box-sizing: border-box;
}

.score-fill {
  height: 100%;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  border-radius: 2px;
  transition: width 0.3s ease;
  max-width: 100%;
  box-sizing: border-box;
}

/* 面试记录问题样式 */
.center-result {
  margin-bottom: 24px;
}

.question-section {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  margin-left: -8px;
}

.question-number {
  width: 24px;
  height: 24px;
  background: linear-gradient(90deg, rgba(98, 175, 255, 0.10) 0%, rgba(156, 65, 255, 0.10) 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #656587;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.question-content {
  flex: 1;
}

.question0 {
  color: #656587;
  font-family: "Afacad-SemiBold", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 0 8px 0;
}

.question1 {
  color: #656587;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
}

.divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  margin: 16px 0;
}

.answer-section {
  margin-bottom: 16px;
  margin-left: 26px;
}

.answer0 {
  color: #656587;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 0 8px 0;
}

.answer1 {
  color: #656587;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
}

.advice-section {
  background: linear-gradient(90deg, rgba(98, 175, 255, 0.10) 0%, rgba(156, 65, 255, 0.10) 100%);
  border: 1px solid rgba(98, 175, 255, 0.2);
  border-radius: 0 8px 8px 0;
  padding: 16px;
  margin-top: 8px;
  position: relative;
  margin-left: 22px;
}

.advice-section::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  background: var(--Linear, linear-gradient(180deg, rgba(177, 110, 249, 0.60) 0%, rgba(126, 180, 235, 0.60) 100%));
  border-radius: 0 2px 2px 0;
}

.advice0 {
  color: #656587;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 0 12px 0;
}

.advice1 {
  color: #656587;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  margin: 0;
}


.score-panel {
  width: 124px;
  height: 131px;
}

.gauge-chart {
  width: 80%;
  height: 80%;
}

.centercard {
  width: 80vw;
  height: 80vh;
  display: flex;
  align-items: stretch;
  gap: 20px;
  margin: 20px auto 0 auto;
  min-height: 80vh;
  position: relative;
}

.panel {
  border-radius: 24px;
  border-width: 1px;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(15px);
  background-color: #fff;
  min-width: 88px;
  min-height: 28px;
  width: 5.5vw;
  height: 4vh;
  cursor: pointer;
  transition: all 0.2s;
}

.panel:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.center {
  flex: 0 0 80%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: transparent;
  height: 80vh;
  min-height: 80vh;
  max-height: 80vh;
  margin: 0;
  gap: 10px;
}

/* 面试总结样式 */
.interview-summary {
  background: linear-gradient(90deg, rgba(98, 175, 255, 0.10) 0%, rgba(156, 65, 255, 0.10) 100%);
  filter: drop-shadow(4px 4px 20px rgba(0, 0, 0, 0.05)) drop-shadow(1px 1px 10px rgba(0, 0, 0, 0.05));
  backdrop-filter: blur(15px);
  border-radius: 12px;
  padding: 15px 20px 25px 20px;
  margin: 0;
}

.summary-header {
  margin-bottom: 10px;
  margin-top: -20px;
}

.summary-title {
  font-size: 18px;
  font-weight: 600;
  color: #656587;

}

.summary-content {
  line-height: 1.6;
}

.summary-text {

  margin: 0;
  line-height: 1.6;
  color: #656587;
font-family: "Source Han Sans CN VF";
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 150%; /* 24px */
}

/* 面试记录样式 */
.interview-record {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.interview-record-header {
  margin-bottom: 16px;
}

.interviewresult {
color: #656587;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 18px;
  font-weight: 400;
}

.right {
  flex: 0 0 25%;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background: #fff;
  border-radius: 12px;
  margin: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  height: 80vh;
  min-height: 80vh;
  max-height: 80vh;
}

.right-header {
  margin-bottom: 20px;
  width: 100%;
  margin-top: -20px;
}

.right-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.timeline-wrapper {
  position: relative;
  width: 100%;
  flex: 1;
}

.timeline-line {
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: transparent;
}

.timeline-items {
  padding-left: 40px;
}

.timeline-item {
  position: relative;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
}

.timeline-item::after {
  content: '';
  position: absolute;
  left: -32px;
  top: 12px;
  bottom: -24px;
  width: 2px;
  background: linear-gradient(180deg, rgba(98, 175, 255, 0.3) 0%, rgba(156, 65, 255, 0.3) 100%);
}

.timeline-dot {
  position: absolute;
  left: -40px;
  width: 24px;
  height: 24px;
  top: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.timeline-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.timeline-time {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.timeline-screenshot {
  width: 100%;
  max-width: 200px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.no-timeline-data {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
}

.right::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.right::-webkit-scrollbar-track {
  background: transparent;
}

.right::-webkit-scrollbar-thumb {
  background: transparent;
}

.right-1 {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 20%;
  width: 100%;
}

.right-2 {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding-right: 1.3vw;
}

.main-card {
  background: #ffffff url("./assets/img/_1-10.png") no-repeat center / cover;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-text-container {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.group_5 {
  width: 15.73vw;
  height: 2.09vw;
  margin: 1.04vw 0 0 1.82vw;
}

.text_36 {
  width: 9.28vw;
  height: 1.41vw;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 1.04vw;
  font-family: Afacad-SemiBold Italic;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.68vw;
}

.label_7 {
  width: 1.36vw;
  height: 1.31vw;
}

.group_6 {
  width: 16.78vw;
  height: 1.41vw;
  margin: 1.45vw 0 0 0.88vw;
}

.group_4 {
  background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
  border-radius: 50%;
  width: 0.42vw;
  height: 0.42vw;
  margin-top: 0.53vw;
}

.text_37 {
  width: 15.84vw;
  height: 1.41vw;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 1.04vw;
  font-family: Afacad-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.group_7 {
  width: 16.78vw;
  height: 10.58vw;
  margin: 0.72vw 0 0 0.88vw;
}

.box_24 {
  background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
  border-radius: 50%;
  width: 0.42vw;
  height: 0.42vw;
  margin-top: 9.69vw;
}

.image-text_16 {
  width: 15.84vw;
  height: 10.58vw;
}

.image_right {
  width: 14.47vw;
  height: 8.55vw;
  box-sizing: border-box;
  padding-bottom: 1.5vh;
}

.text-group_7 {
  width: 15.84vw;
  height: 1.41vw;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 1.04vw;
  font-family: Afacad-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.63vw;
}

.group_8 {
  width: 16.78vw;
  height: 10.58vw;
  margin: 0.31vw 0 0 0.88vw;
}

.section_4 {
  background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
  border-radius: 50%;
  width: 0.42vw;
  height: 0.42vw;
  margin-top: 9.69vw;
}

.image-text_17 {
  width: 15.84vw;
  height: 10.58vw;
}

.text-group_8 {
  width: 15.84vw;
  height: 1.41vw;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 1.04vw;
  font-family: Afacad-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.63vw;
}

.group_9 {
  width: 16.78vw;
  height: 10.58vw;
  margin: 0.31vw 0 0vw 0.88vw;
}

.block_1 {
  background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
  border-radius: 50%;
  width: 0.42vw;
  height: 0.42vw;
  margin-top: 9.69vw;
}

.image-text_18 {
  width: 15.84vw;
  height: 10.58vw;
}

.text-group_9 {
  width: 15.84vw;
  height: 1.41vw;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 1.04vw;
  font-family: Afacad-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.63vw;
}

/* 头像放大模态框样式 */
.avatar-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.avatar-modal-content {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  position: relative;
  max-width: 80%;
  max-height: 80%;
  overflow: hidden;
}

.avatar-modal-image {
  margin-bottom: 15px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.avatar-modal-info {
  text-align: center;
  margin-bottom: 20px;
}

.avatar-modal-info h3 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.avatar-modal-info p {
  font-size: 16px;
  color: #666;
}

.avatar-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #eee;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
  color: #555;
  transition: background 0.2s ease;
}

.avatar-modal-close:hover {
  background: #ddd;
}

/* PDF简历预览弹窗样式 */
.resume-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.resume-modal-content {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  width: 90%;
  height: 90%;
  max-width: 1200px;
  max-height: 800px;
  overflow: hidden;
}

.resume-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e5e5;
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;
}

.resume-modal-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.resume-modal-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.resume-download-btn {
  background: linear-gradient(90deg, rgba(126, 180, 235, 1) 0%, rgba(177, 110, 249, 1) 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.resume-download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
}

.resume-modal-close {
  background: #f5f5f5;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  color: #666;
  transition: all 0.2s ease;
}

.resume-modal-close:hover {
  background: #e5e5e5;
  color: #333;
}

.resume-modal-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.resume-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: #f5f5f5;
}

.resume-no-file {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #999;
  font-size: 16px;
}

.person-detail {
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0;
}

.right-date {
  position: absolute;
  top: -60px;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 24px;
}

.date-text {
  font-size: 16px;

  font-weight: 600;
  background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
}
</style>